'use strict';

module.exports = require('./lib/parser');




// WEBPACK FOOTER //
// ./index.js